import { ref } from "vue";

const getCharacters = ( rawcharacters ) => {
    const characters = ref([null])
    const errorc = ref(null)

    const loadch = async() => {
        if( rawcharacters ){
            console.log('>>>'+rawcharacters) 


                let promises = rawcharacters.map(async url => {
                let a = await fetch(url);
                return a.json()
                })

            characters.value = await Promise.all(promises)

            

        }



    }
return { characters, loadch }


}
export default getCharacters